// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"930b45f0","239":"3128e639","425":"9fcede7e","455":"996978b3","977":"94dfa982"}[chunkId] + ".chunk.js";
};